import React from 'react'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
import { isLoaded, isEmpty } from 'react-redux-firebase'

import AssessmentsByCompany from './AssessmentsByCompany'
import Assignment from './Assignment' // Note container is bypassed
import Employees from '../containers/Employees'
import { cp9 as cp} from '../containers/cps-gci'
import { cps as cpsJSON} from '../containers/cps-jfc-2019'

import GenericAccounts from './GenericAccounts.js'
//import createJSONDownload, { formatBackup } from '../services/download'

/*
            <!-- debug -->
         <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
             <PrimaryButton text="pop assessments" onClick={e => { selectActivityId('DHvmqf15hUeFplS8sVww'); populateCpsIfNeeded('DHvmqf15hUeFplS8sVww')} } />           
            {cps.map( (cp,i) => <div key={i}>{cp.name}</div>)}
            </div></div>

            */

const renderActivities = (assessment,id) => {
    const activities = assessment[id].activities
    const keys = Object.keys(activities)
    return JSON.stringify(keys.map(key => { 
        //return activities[key].name
        return key
    }  ) )

}


/**
 *  && isLoaded(backup.activities) && isLoaded(backup.assessmentsByRater)
     && isLoaded(backup.employees) && isLoaded(backup.users)
 */
export default ({
    createAssessments,
    backup,
    competencies,
    cleanCps,
    addJSONCps,addCp,updateCpIds,
    copyCps,
    checkPermissions, permissions,
    selectActivityId,populateCpsIfNeeded,selectedActivityId,cps,
    activities, firebase, auth, profile,
    loadAssessmentsSubcollections, assessmentActivities, createCps}) =>    
{ return profile && profile.permissions && profile.permissions.indexOf('Admin') >= 0 
? <div>
    <div className="ms-Grid">
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
        <Employees />
        </div></div>
    </div>
    <AssessmentsByCompany />
    <Assignment items={backup.assessmentsByRater} />

        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <PrimaryButton text='Create Assessments' onClick={createAssessments('parameterized pme')} />
        </div></div>

     <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
     {/*isLoaded(backup) && isLoaded(backup.competencies) && isLoaded(backup.activities)
            ? <a href={createJSONDownload(formatBackup(backup) )} download={'backup.json'} >Backup</a>
     : 'Loading' */}
     </div></div>
     <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
        <h1>Competencies</h1>
        {isLoaded(competencies) 
            ? Object.entries(competencies)
                .sort( (a,b) =>  a[1].sort - b[1].sort  )
                .map( ([id,cp],i) => 
                <div key={i}><a href={'/*createJSONDownload(cp)*/'} download={cp.name + '.json'} > {cp.name}</a>{id}</div>)
        :'Loading'}
     </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12"><GenericAccounts /></div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <PrimaryButton text='Update Cp Ids <id>' onClick={updateCpIds('<id>')} />
        </div></div>
     <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <PrimaryButton text='Clean Cps' onClick={cleanCps} />
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <PrimaryButton text={'Add JSON Competencies ' +  cpsJSON.length} onClick={addJSONCps(cpsJSON)} />
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <PrimaryButton text={'Add Cp ' + cp.name} onClick={addCp(cp)} />
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
        <PrimaryButton text="Copy Cps" onClick={loadAssessmentsSubcollections('KgOVEZRvclGmfAc03IQv')} />
        {assessmentActivities ? renderActivities(assessmentActivities,'KgOVEZRvclGmfAc03IQv') : ''}
        <PrimaryButton text="Update Cps" onClick={createCps(assessmentActivities,'KgOVEZRvclGmfAc03IQv')} />
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <h1>Activities</h1>
            {activities ? JSON.stringify(activities.map(activity =>
                            activity.competencies.map(cp =>
                                cp.get().then(item =>
                                    'test' //console.log(item.data())
                                ) ) )   ):''}
        </div></div>

        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <br/>
            <PrimaryButton text="Load Assessments / Check Permissions" onClick={checkPermissions} />
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            {permissions.indexOf('Error') >= 0 ? 'Incorrect login details': ''}
        </div></div>       


        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            {firebase.authError}
        </div></div>       

        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <h2>Auth</h2>
            {
                isLoaded(auth)
                ? <span>Loading...{JSON.stringify(auth, null, 2)} {JSON.stringify(profile)}</span>
                : isEmpty(auth)
                ? <span>Not Authed</span>
                : <pre>{JSON.stringify(auth, null, 2)}</pre>
            }            
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
            <h2>User Profile</h2>
            <span>{ isLoaded(auth) ? JSON.stringify(profile) : ''}</span>
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
         
            <PrimaryButton text="pop assessments" onClick={e => { selectActivityId('DHvmqf15hUeFplS8sVww'); populateCpsIfNeeded('DHvmqf15hUeFplS8sVww')} } />           
            {cps.map( (cp,i) => <div key={i}>{cp.name}</div>)}
        </div></div>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
        <h2>Permissions</h2>
        { permissions.length === 0 || permissions.indexOf('Error') >= 0 ? JSON.stringify(permissions) : '' }
        { permissions.indexOf('Assessments') >= 0 ?  JSON.stringify(permissions) : 'No permissions' }  
        </div></div>
</div>
: ''}





// WEBPACK FOOTER //
// ./src/admin/components/Admin.js